module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/particular07-ca177af5945955686c173c1d8a963b4a.png";